import React from "react";
import BtnAction from "./main.content.btn.action";
import { useAlluser } from "context/AlluserContext";

export default function TrHead({ data, setData, setActionData }) {
  const { filterData } = useAlluser();
  const userFields = filterData?.userFields ?? [];
  const columns = filterData?.columnObjs ?? {};
  const columnData = [{ field: "", display_name: "" }];
  for (const i in userFields) {
    const field = userFields[i];
    if (field === "active") continue;
    const display_name = columns?.[field]?.display_name ?? field;
    columnData.push({ field: field, display_name: display_name });
  }
  columnData.push({ field: "active", display_name: "Active" });
  columnData.push({ field: "view", display_name: "View" });
  let list = [];
  for (const i in columnData) {
    let detail = "";
    list.push(
      <th
        key={"col-" + i}
        className={"th-" + columnData[i].field.toLocaleLowerCase()}
      >
        {columnData[i].display_name}
        {detail}
      </th>
    );
  }
  if (data.userSess?.userCanAccessHrAssign && data.userSess?.isAdmin) {
    list.push(
      <th key={"col-" + columnData.length} className="th-bulk-action">
        <BtnAction
          setActionData={setData.setActionData}
          actionData={data.actionData}
          active_page={data.active_page}
          userSess={data.userSess}
        />
      </th>
    );
  }
  return <tr key="row-0">{list}</tr>;
}
